import React from 'react';
import styles from './TokenSettingsTab.module.css';
import { FieldRenderProps } from './types';
import KeyIndicator from './KeyIndicator';

const NumberCard: React.FC<FieldRenderProps> = ({ field, draft, initialDraft, settings, showKeys, highlighted, saving, onNumberChange }) => {
  const disabled = (!!field.dependsOn && draft[field.dependsOn] !== 'true')
    || (!!field.disabledWhen && field.disabledWhen(draft));
  const value = draft[field.key] ?? '';
  const defaultVal = settings[field.key]?.default ?? field.fallbackDefault;
  const isModified = value !== (initialDraft[field.key] ?? '');
  const diffFromDefault = value !== String(defaultVal);
  return (
    <div className={`${styles.card} ${disabled ? styles.cardDisabled : ''} ${highlighted ? styles.cardHighlight : ''}`}>
      <div className={styles.cardHeader}>
        <span className={styles.cardLabel}>
          {field.label}
          <KeyIndicator field={field} showKeys={showKeys} />
        </span>
        {isModified && <span className={styles.modifiedBadge}>Modified</span>}
      </div>
      <p className={styles.cardDescription}>{field.description}</p>
      <input
        type="number"
        className={styles.cardInput}
        value={value}
        min={field.min}
        max={field.max}
        step={field.step ?? 1}
        disabled={disabled || saving}
        onChange={e => onNumberChange(field.key, e.target.value)}
      />
      {diffFromDefault && <span className={styles.defaultHint}>Default: {defaultVal}</span>}
      {disabled && field.dependsOn && draft[field.dependsOn] !== 'true' && (
        <p className={styles.disabledNote}>{field.disabledNote ?? 'Disabled while the setting above is off.'}</p>
      )}
      {disabled && field.disabledWhen?.(draft) && (
        <p className={styles.disabledNote}>{field.disabledNote ?? 'Disabled by a setting above.'}</p>
      )}
    </div>
  );
};

export default NumberCard;
